<div [@pageTransition]>
    <p>users works!</p>
</div>